import { CardContent, Card, Grid, Divider, Box, MenuItem, TextField, IconButton, ClickAwayListener, Button, useMediaQuery } from "@mui/material";
import { ReactComponent as CalendarIcon } from '../../../assets/icons/main/calendar-icon.svg';
import { useEffect, useState } from "react";
import { DateRange, RangeKeyDict } from 'react-date-range';
import { subDays, format } from "date-fns";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import '../../../styles/calender.scss';
import dayjs from "dayjs";
import { useTheme } from "@emotion/react";
import { palette } from '../../../theme/palette';

const CalendarOptions = [
    'Today',
    'Yesterday',
    'Last 7 Days',
    'Last Month',
    'This Month',
    'Custom Range'
];

const CalendarDateRange = ({ getSelectedDate, defRange, defStartDate, defEndDate }: any) => {
    const themeData: any = useTheme();
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const [showMenu, setShowMenu] = useState(false);
    const [showCustomRange, setShowCustomRange] = useState(false);
    const [dateRange, setDateRange] = useState(`${format(new Date(), 'MMM dd, yyyy')} - ${format(new Date(), 'MMM dd, yyyy')}`);
    const [dateRangeTimeStamp, setDateRangeTimeStamp] = useState<any>({});
    const [defaultRange, setDefaultRange] = useState<String>(defRange);
    const [selectionRange, setSelectionRange] = useState<RangeKeyDict>({
        selection: {
            startDate: defStartDate ? defStartDate : new Date(),
            endDate: defEndDate ? defEndDate : new Date(),
            key: 'selection',
        },
    });

    const [isApplyDisabled, setIsApplyDisabled] = useState(true);
    const responsiveSize = useMediaQuery('(max-width:1100px)');

    const handleTextFieldClick = () => {
        setShowMenu(!showMenu);
        setShowCustomRange(false);
    };

    const handleMenuClose = () => {
        setShowMenu(false);
        setShowCustomRange(false);
        setIsApplyDisabled(true);
    };

    useEffect(() => {
        if (defRange === 'Custom Range') {
            const { startDate, endDate } = selectionRange.selection;
            if (startDate && endDate) {
                setDateRange(`${format(startDate, 'MMM dd, yyyy')} - ${format(endDate, 'MMM dd, yyyy')}`);
                setDateRangeTimeStamp({ start_date: dayjs(startDate).format('MMM DD, YYYY'), end_date: dayjs(endDate).format('MMM DD, YYYY') })
            }
        } else {
            handleSelectRange(defRange);
        }
    }, [defRange])

    const handleSelectRange = (range: string) => {
        const today = new Date();
        let startDate: Date | undefined, endDate: Date | undefined;
        setDefaultRange(range);
        if (range === 'Today') {
            startDate = today;
            endDate = today;
        } else if (range === 'Yesterday') {
            startDate = subDays(today, 1);
            endDate = today;
        } else if (range === 'Last 7 Days') {
            startDate = subDays(today, 6);
            endDate = today;
        } else if (range === 'Last Month') {
            startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        } else if (range === 'This Month') {
            startDate = startOfMonth;
            endDate = endOfMonth;
        } else if (range === 'Custom Range') {
            setShowCustomRange(true);
            return;
        }

        if (startDate && endDate) {
            setDateRange(`${format(startDate, 'MMM dd, yyyy')} - ${format(endDate, 'MMM dd, yyyy')}`);
            setDateRangeTimeStamp({ start_date: dayjs(startDate).format('MMM DD, YYYY'), end_date: dayjs(endDate).format('MMM DD, YYYY') })
            getSelectedDate({ start_date: dayjs(startDate).format('MMM DD, YYYY'), end_date: dayjs(endDate).format('MMM DD, YYYY') });
        }
        handleMenuClose();
    };

    const handleApplyCustomRange = () => {
        const { startDate, endDate } = selectionRange.selection;

        if (startDate && endDate) {
            setDateRange(`${format(startDate, 'MMM dd, yyyy')} - ${format(endDate, 'MMM dd, yyyy')}`);
            setDateRangeTimeStamp({ start_date: dayjs(startDate).format('MMM DD, YYYY'), end_date: dayjs(endDate).format('MMM DD, YYYY') })
            getSelectedDate({ start_date: dayjs(startDate).format('MMM DD, YYYY'), end_date: dayjs(endDate).format('MMM DD, YYYY') });
        }

        handleMenuClose();
    };

    // useEffect(() => {
    //     if (!isEmpty(dateRangeTimeStamp)) {
    //         getSelectedDate(dateRangeTimeStamp);
    //     }
    // }, [dateRangeTimeStamp])

    const handleCancel = () => {
        handleMenuClose();
    };

    const handleDateRangeChange = (item: RangeKeyDict) => {
        setSelectionRange(item);
        const { startDate, endDate } = item.selection;

        if (startDate && endDate) {
            setIsApplyDisabled(false);
        } else {
            setIsApplyDisabled(true);
        }

    };

    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                position: 'relative',
                marginLeft:'16px'
            }}
        >
            <Box>
                <TextField
                    variant="outlined"
                    size="small"
                    value={dateRange}
                    fullWidth
                    onClick={handleTextFieldClick}
                    InputProps={{
                        endAdornment: (
                            <IconButton onClick={handleTextFieldClick} sx={{ p: 0 }}>
                                <CalendarIcon />
                            </IconButton>
                        )
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            color: '#7382A9',
                            padding: '10px 16px',
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0,
                            width: '208px'
                        }
                    }}
                />
            </Box>

            {showMenu && (
                <ClickAwayListener onClickAway={handleMenuClose}>
                    <Card
                        sx={{
                            position: 'absolute',
                            top: '45px',
                            right: '0px',
                            display: 'flex',
                            zIndex: 999,
                            borderRadius: '0px 0px 18px 18px',
                            padding: '0px',
                            width: showCustomRange ? 'auto' : '173px',
                            backgroundColor: `${palette.primary.contrastText} !important`,
                        }}
                    >
                        <CardContent
                            sx={{
                                padding: '0px',
                                display: 'flex',
                                '&:last-child': {
                                    paddingBottom: '0px',
                                },
                            }}
                        >
                            {showCustomRange && (
                                <Grid item sx={{ padding: '24px' }}>
                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={handleDateRangeChange}
                                        moveRangeOnFirstSelection={false}
                                        ranges={[selectionRange.selection]}
                                        months={2}
                                        direction = {responsiveSize ? 'vertical' : 'horizontal'}
                                        dateDisplayFormat="MM/dd/yyyy"
                                    />
                                    <Box display='flex' justifyContent='flex-end' sx={{ pt: 2 }}>
                                        <Button
                                            variant="outlined"
                                            onClick={handleCancel}
                                            sx={{ mr: 2 }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={handleApplyCustomRange}
                                            disabled={isApplyDisabled}
                                        >
                                            Apply
                                        </Button>
                                    </Box>
                                </Grid>
                            )}
                            {showCustomRange && <Divider orientation="vertical" flexItem />}

                            <Grid item sx={{ padding: '24px', width: showCustomRange ? '35%' : '100%' }}>
                                {CalendarOptions.map((option, index) => (
                                    <MenuItem
                                        key={index}
                                        value={option}
                                        onClick={() => handleSelectRange(option)}
                                        sx={{
                                            color:  defaultRange === option ? palette.primary.contrastText :  '#434D67',
                                            fontSize: '16px',
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            marginBottom: index + 1 === CalendarOptions.length ? '' : '16px',
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            backgroundColor: defaultRange === option ? themeData.palette.primary.main : '#D9DFED80',
                                            '&:hover, &:focus': {
                                                backgroundColor: themeData.palette.primary.main,
                                                color: palette.primary.contrastText,
                                            }
                                        }}
                                    >{option}</MenuItem>
                                ))}
                            </Grid>
                        </CardContent>
                    </Card>
                </ClickAwayListener>
            )}
        </Box>
    );
};

export default CalendarDateRange;
